module.exports = __webpack_public_path__ + "static/media/YF92_3.b4dde685.jpg";